<template>
  <div class="app-container">
    <img class="img" :src="orderError"/>
    <p class="error-title">订单创建失败</p>
    <p class="error-tips">请联系班主任下单</p>
  </div>
</template>

<script>
import orderError from '@/assets/img/conference-qrcode/order-error.png'
export default {
  data () {
    return {
      orderError
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  width: 284px;
  min-height: 100vh;
  overflow: hidden;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.img {
  width: 166px;
  height: 156px;
  margin: 220px 58px 0 58px;
}
.error-title {
  width: 276px;
  height: 48px;
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  color: #464c54;
  line-height: 48px;
  margin: 32px auto 8px auto;
}
.error-tips {
  width: 284px;
  height: 40px;
  font-size: 28px;
  font-weight: 400;
  text-align: center;
  color: #9199a3;
  line-height: 40px;
}
</style>
